import React from "react";
import { Modal } from "react-bootstrap";
import Form from "../Components/Comman/Form";
import Joi from "joi-browser";
import auth from "../Services/authService";
import { getAlert } from "../Services/appAlerts";
import { validatePassword } from "../Services/passwordValidator";

const CHANGE_PASSWORD_STYLES = {
  modalContent: {
    borderRadius: "0px",
    overflow: "hidden",
    border: "1px solid rgba(226, 232, 240, 1)",
    boxShadow: "0 24px 60px rgba(15, 23, 42, 0.16)"
  },
  modalHeader: {
    padding: "18px 22px",
    borderBottom: "1px solid #e2e8f0",
    background: "#ffffff"
  },
  headerContent: {
    width: "100%",
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    gap: "14px",
    paddingRight: "0"
  },
  titleWrap: {
    display: "flex",
    alignItems: "center",
    gap: "14px"
  },
  headerIcon: {
    width: "44px",
    height: "44px",
    borderRadius: "0px",
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    background: "#f1f5f9",
    color: "#0f172a",
    fontSize: "20px",
    boxShadow: "none"
  },
  eyebrow: {
    fontSize: "11px",
    fontWeight: 600,
    letterSpacing: "0.12em",
    textTransform: "uppercase",
    color: "#4f46e5",
    marginBottom: "4px"
  },
  title: {
    fontSize: "21px",
    fontWeight: 600,
    color: "#0f172a",
    lineHeight: 1.1,
    margin: 0
  },
  subtitle: {
    fontSize: "12px",
    color: "#64748b",
    marginTop: "4px"
  },
  closeButton: {
    width: "38px",
    height: "38px",
    borderRadius: "0px",
    border: "1px solid rgba(226, 232, 240, 1)",
    background: "#ffffff",
    color: "#64748b",
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    fontSize: "16px",
    fontWeight: 600,
    boxShadow: "0 2px 6px rgba(15, 23, 42, 0.04)",
    cursor: "pointer",
    transition: "all 0.2s ease",
    flexShrink: 0
  },
  modalBody: {
    padding: "20px 22px",
    background: "#ffffff"
  },
  helperCard: {
    borderRadius: "0px",
    padding: "16px",
    background: "#ffffff",
    border: "1px solid rgba(191, 219, 254, 0.9)",
    marginBottom: "16px"
  },
  helperTitle: {
    fontSize: "14px",
    fontWeight: 600,
    color: "#0f172a",
    marginBottom: "8px"
  },
  helperText: {
    fontSize: "12px",
    lineHeight: 1.6,
    color: "#64748b",
    marginBottom: "10px"
  },
  helperList: {
    margin: 0,
    paddingLeft: "18px",
    color: "#475569",
    fontSize: "12px",
    lineHeight: 1.7
  },
  formCard: {
    borderRadius: "0px",
    border: "1px solid rgba(226, 232, 240, 1)",
    background: "#ffffff",
    padding: "18px 18px 6px 18px"
  },
  modalFooter: {
    padding: "16px 22px 20px 22px",
    borderTop: "1px solid rgba(226, 232, 240, 0.9)",
    background: "#ffffff"
  },
  footerActions: {
    width: "100%",
    display: "flex",
    justifyContent: "flex-end",
    gap: "10px"
  },
  cancelButton: {
    display: "inline-flex",
    alignItems: "center",
    gap: "8px",
    borderRadius: "0px",
    border: "1px solid #cbd5e1",
    background: "#ffffff",
    color: "#334155",
    padding: "9px 18px",
    fontSize: "13px",
    fontWeight: 600,
    boxShadow: "0 2px 6px rgba(15, 23, 42, 0.04)",
    cursor: "pointer",
    transition: "all 0.2s ease"
  },
  saveButton: {
    display: "inline-flex",
    alignItems: "center",
    gap: "8px",
    borderRadius: "0px",
    border: "1px solid #2563eb",
    background: "#2563eb",
    color: "#ffffff",
    padding: "9px 18px",
    fontSize: "13px",
    fontWeight: 600,
    boxShadow: "0 2px 6px rgba(37, 99, 235, 0.2)",
    cursor: "pointer",
    transition: "all 0.2s ease"
  },
  saveButtonDisabled: {
    opacity: 0.55,
    boxShadow: "none"
  }
};

class ChangePassword extends Form {
  constructor(props) {
    super(props);
    this.state = {
      data: {},
      errors: {},
    };
  }

  schema = {
    oldPassword: Joi.string().required().label("Old Password"),
    newPassword: Joi.string().required().min(8).max(14).label("New Password"),
    confirmPassword: Joi.string()
      .required()
      .valid(Joi.ref("newPassword"))
      .options({ language: { any: { allowOnly: "must match new password" } } })
      .label("Confirm Password"),
  };

  doSubmit = async () => {
    try {
      const { data } = this.state;
      const passResult = validatePassword(data.newPassword);

      if (passResult.isValid) {
        const user = auth.getCurrentUser();
        await auth.changePassword(
          data.oldPassword,
          data.newPassword,
          user.id
        );
        getAlert("", "Password Changed Successfully", "success");
        if (typeof this.props.handleModalShowHide === "function") {
          this.props.handleModalShowHide();
        }
      } else {
        getAlert(
          "Strong Password Required",
          passResult.htmlMessage || passResult.message,
          "error"
        );
      }
    } catch (ex) {
      if (ex.response && ex.response.status === 400) {
        const errors = { ...this.state.errors };
        errors.oldPassword = ex.response.data.message;
        this.setState({ errors });
      }
    }
  };

  componentWillReceiveProps = () => {
    this.setState({ data: {}, errors: {} });
  };

  // getAlert(title, message, type) {
  //   return Swal.fire({
  //     title: title,
  //     text: message,
  //     icon: type,
  //     confirmButtonText: "Close",
  //     confirmButtonColor: "#d33",
  //     onClose: () => {
  //       if (type === "success") {
  //         //window.location = "/AdminLogin";
  //         auth.logout();
  //         window.location = "/Login";
  //       }
  //     },
  //   });
  // }

  render() {
    const { handleModalShowHide, showHide } = this.props;
    const isSaveDisabled = this.validate();
    return (
      <Modal
        show={showHide}
        size="lg"
        centered
        contentClassName="change-password-modal-content"
      >
        <style>
          {`
            .change-password-modal-content,
            .modal-content {
              border-radius: 0px !important;
              overflow: ${CHANGE_PASSWORD_STYLES.modalContent.overflow};
              border: ${CHANGE_PASSWORD_STYLES.modalContent.border};
              box-shadow: ${CHANGE_PASSWORD_STYLES.modalContent.boxShadow};
            }
            .change-password-modal-content .form-control {
              border-radius: 0px !important;
            }
          `}
        </style>
        <Modal.Header style={CHANGE_PASSWORD_STYLES.modalHeader}>
          <div style={CHANGE_PASSWORD_STYLES.headerContent}>
            <Modal.Title as="div" style={CHANGE_PASSWORD_STYLES.titleWrap}>
              <div style={CHANGE_PASSWORD_STYLES.headerIcon}>
                <i className="fa fa-lock" aria-hidden="true"></i>
              </div>
              <div>
                <div style={CHANGE_PASSWORD_STYLES.title}>Change Password</div>
                <div style={CHANGE_PASSWORD_STYLES.subtitle}>Create a stronger password to keep your account protected.</div>
              </div>
            </Modal.Title>
            <button
              type="button"
              style={CHANGE_PASSWORD_STYLES.closeButton}
              onClick={handleModalShowHide}
              aria-label="Close change password"
            >
              <i className="fa fa-times" aria-hidden="true"></i>
            </button>
          </div>
        </Modal.Header>
        <Modal.Body style={CHANGE_PASSWORD_STYLES.modalBody}>
          <div style={CHANGE_PASSWORD_STYLES.helperCard}>
            <div style={CHANGE_PASSWORD_STYLES.helperTitle}>Password requirements</div>
            <div style={CHANGE_PASSWORD_STYLES.helperText}>
              Use a password that is hard to guess and easy for you to remember.
            </div>
            <ul style={CHANGE_PASSWORD_STYLES.helperList}>
              <li>Must be 8 to 14 characters and contain no spaces.</li>
              <li>Must include uppercase letters (A-Z) and lowercase letters (a-z).</li>
              <li>Must include at least one number (0-9).</li>
              <li>Must include at least one special character such as `!`, `@`, `#`, `$`, `%`, or `?`.</li>
            </ul>
          </div>
          <div style={CHANGE_PASSWORD_STYLES.formCard}>
            <div className="row">
              <div className="col-md-12">
                {this.renderInput("oldPassword", "Old Password", "password")}
              </div>
              <div className="col-md-12">
                {this.renderInput("newPassword", "New Password", "password")}
              </div>
              <div className="col-md-12">
                {this.renderInput(
                  "confirmPassword",
                  "Confirm Password",
                  "password"
                )}
              </div>
            </div>
          </div>
        </Modal.Body>
        <Modal.Footer style={CHANGE_PASSWORD_STYLES.modalFooter}>
          <div style={CHANGE_PASSWORD_STYLES.footerActions}>
            <button
              type="button"
              style={CHANGE_PASSWORD_STYLES.cancelButton}
              onClick={handleModalShowHide}
            >
              <i className="fa fa-times" aria-hidden="true"></i>
              Cancel
            </button>
            <button
              type="button"
              style={{
                ...CHANGE_PASSWORD_STYLES.saveButton,
                ...(isSaveDisabled ? CHANGE_PASSWORD_STYLES.saveButtonDisabled : {})
              }}
              disabled={isSaveDisabled}
              onClick={this.handleSubmit}
            >
              <i className="fa fa-check" aria-hidden="true"></i>
              Save Password
            </button>
          </div>
        </Modal.Footer>
      </Modal>
    );
  }
}

export default ChangePassword;
